export default function useLoadingValues(...values) {
	return values.reduce(
		(result, [value, loading, error]) => [[...result[0], value], result[1] || loading, result[2] || error],
		[[], false, false],
	);
}
